var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',_vm._g({staticClass:"payment-brand-avatar",style:(_vm.avatarStyle)},on),[_c('PaymentIcon',{attrs:{"name":_vm.normalizedBrand,"size":_vm.size,"color":_vm.iconColor}})],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.friendlyBrandName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }